<template>
  <section
    :id="section.id"
    class="content-section"
  >
    <div class="container">
      <div class="small-content">
        <div class="columns flex items-center justify-between">
          <div class="left-col">
            <h2
              :class="[
                'section-title section-title-margin',
                section.is_visible ? 'fade-in' : 'fade-out',
              ]"
            >
              {{ getContent('section_3.title_row_1') }}
              <br>
              {{ getContent('section_3.title_row_2') }}
            </h2>
            <div
              :class="[
                'content-text',
                section.is_visible ? 'fade-in' : 'fade-out',
              ]"
              :style="{ transitionDelay: getFadeTransitionDelay(1) }"
            >
              <p>
                {{ getContent('section_3.description_paragraph_1') }}
              </p>
              <br>
              <p>
                {{ getContent('section_3.description_paragraph_2') }}
              </p>
            </div>
          </div>
          <div
            :class="[
              'right-col',
              section.is_visible ? 'fade-in' : 'fade-out',
            ]"
            :style="{ transitionDelay: getFadeTransitionDelay(2) }"
          >
            <div class="content-image-wrap">
              <NuxtImg
                width="442"
                height="575"
                loading="lazy"
                sizes="442px sm:474px"
                src="/content_section_three_hero_1.webp"
                :alt="getContent('section_3.image_alt_1')"
                class="content-image-1 levitation"
              />
              <NuxtImg
                width="222"
                height="125"
                loading="lazy"
                sizes="198px sm:222px"
                src="/content_section_three_hero_2.webp"
                :alt="getContent('section_3.image_alt_2')"
                class="content-image-2 levitation-2"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      :class="[
        'image-background bg-image',
        section.is_visible ? 'fade-in' : 'fade-out',
      ]"
      :style="{ transitionDelay: getFadeTransitionDelay(2) }"
    />
  </section>
</template>

<script>
export default {
  name: 'ContentSectionThree',
  data: () => ({
    section: {
      id: contentSectionId.three,
      is_visible: true,
    },
  }),
  mounted() {
    this.section.is_visible = false
    initObserver(this.section)
  },
};
</script>

<style lang="scss" scoped>
.content-section {
  padding-top: 164px;
  position: relative;

  .columns {
    flex-direction: row;
    gap: 32px;

    .left-col {
      z-index: 1;
      max-width: 442px;
      position: relative;
    }

    .right-col {
      position: relative;

      .content-image-wrap {
        z-index: 1;
        width: 474px;
        height: 575px;
        position: relative;
      }

      .content-image-1 {
        width: 442px;
        height: 575px;
        display: block;
        object-fit: cover;
        margin-left: auto;
      }

      .content-image-2 {
        left: 0;
        bottom: 30%;
        width: 222;
        height: 125;
        object-fit: cover;
        position: absolute;
        animation-delay: 2s;
        transform: translateY(-4%);
      }
    }
  }

  .image-background {
    left: 50%;
    top: 127px;
    width: 570px;
    height: 442px;
    position: absolute;
    transform: translateX(-50%);
    background-image: url('@/assets/images/content_section_three_meteors.webp');
  }
}

@media only screen and (max-width: $sm) {
  .content-section {
    padding-top: 32px;

    .columns {
      flex-direction: column;
      gap: 0px;

      .left-col {
        max-width: 100%;
      }

      .right-col {

        .content-image-wrap {
          width: 442px;
          height: 512px;

          .content-image-1 {
            width: 394px;
            height: 512px;
          }

          .content-image-2 {
            width: 198px;
            height: 111px;
          }
        }
      }
    }

    .image-background {
      top: auto;
      left: auto;
      right: 50%;
      bottom: 62px;
      width: 508px;
      height: 394px;
      transform: translateX(0%);
    }
  }
}
</style>
